import { State } from "common/types/redux";

import { premiumHasAccessToSmartLearning } from "seneca-common/features/subscriptions/features/subscription/selectors";

import { getLearningMode, LearningMode } from "features/classroom/state";

export default function isSmartLearningActive(state: State) {
  return (
    premiumHasAccessToSmartLearning(state) &&
    getLearningMode(state) === LearningMode.smartLearning
  );
}
